<template>
  <MDBSideNav right v-model="drawerState" id="ProjectTaggingDrawer" mode="push" contentSelector="#ProjectTagging" :sidenavWidth="354">
    <div class="drawer-container">
      <div class="drawer-header">
        <div class="--label">
          <label>Manage Assignees</label>
          <span class="SproutIcon SproutIcon-cross-regular" @click="handleDrawerClose"></span>
        </div>
        Assign or remove employees for the {{ projectNameDescription }} project:
      </div>
      <div class="drawer-search">
        <div class="search-div">
          <ProjectTaggingDrawerSearch />
          <MDBBtn @click="setFilterVisibility" outline="success" class="text-capitalize searchBy-btn">
            Search By
            <span class="SproutIcon SproutIcon-caret-up-regular" v-if="filterVisibility"></span>
            <span class="SproutIcon SproutIcon-caret-down-regular-1" v-else></span>
          </MDBBtn>
        </div>
        <div v-if="filterVisibility" class="dropdown-filter">
          <SPASelect label="Search By" v-model:options="drawerFilterOptions" v-model:selected="localSelectedDrawerFilter" />
        </div>
      </div>
      <div class="drawer-pagination">
        <ProjectTaggingDrawerPagination />
      </div>
      <div class="drawer-list d-flex align-items-center justify-content-center">
        <MDBSpinner v-if="drawerListContainerLoader" />
        <ProjectTaggingDrawerList v-else />
      </div>
      <div class="drawer-allBtns">
        <MDBBtn color="primary" class="text-capitalize" :ripple="false" @click.stop.prevent="handleClickAll('assign-all')"> Assign All </MDBBtn>
        <MDBBtn outline="danger" class="text-capitalize" :ripple="false" @click.stop.prevent="handleClickAll('remove-all')">Remove All</MDBBtn>
      </div>
    </div>
  </MDBSideNav>
</template>

<script>
import { MDBSideNav, MDBBtn, MDBSpinner } from 'mdb-vue-ui-kit';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';
import { storeToRefs } from 'pinia';
import ProjectTaggingDrawerSearch from './ProjectTaggingDrawerSearch.vue';
import ProjectTaggingDrawerList from './ProjectTaggingDrawerList.vue';
import ProjectTaggingDrawerPagination from './ProjectTaggingDrawerPagination.vue';
import { PostEmployees } from '../../../../services/ProjectTagging/PostEmployees';
import { PatchEmployees } from '../../../../services/ProjectTagging/PatchEmployees';
import { computed, ref } from 'vue';
import SPASelect from '../../../../components/SPASelect.vue';
export default {
  components: {
    MDBSideNav,
    ProjectTaggingDrawerSearch,
    ProjectTaggingDrawerList,
    MDBBtn,
    ProjectTaggingDrawerPagination,
    MDBSpinner,
    SPASelect,
  },
  setup() {
    const projectTagging = useProjectTaggingStore();
    const {
      drawerState,
      projectName,
      projectId,
      drawerEmployeeList,
      toastAssignAllState,
      toastRemoveAllState,
      drawerAllBtnLoader,
      drawerListContainerLoader,
      drawerPagination,
      drawerFilterOptions,
      localSelectedDrawerFilter,
      drawerSearch,
      projectNameDescription,
    } = storeToRefs(projectTagging);

    const resetOptions = (compareItem) => {
      return drawerFilterOptions.value.map((item) => {
        return {
          ...item,
          selected: item.value == compareItem,
        };
      });
    };
    const handleDrawerClose = () => {
      drawerState.value = false;
      drawerFilterOptions.value = resetOptions('LastName');
      drawerSearch.value = '';
      filterVisibility.value = false;
    };
    const afterHandleClick = (type) => {
      projectTagging.getEmployeeLookup({ PageNumber: drawerPagination.value.currentPage });
      drawerAllBtnLoader.value = false;
      if (type == 'assign-all') toastAssignAllState.value = true;
      else toastRemoveAllState.value = true;
    };
    const getAllCurrentPageEmployees = computed(() => {
      return drawerEmployeeList.value.map((object) => {
        return object.employeeId;
      });
    });
    const handleClickAll = (type) => {
      drawerAllBtnLoader.value = true;
      const params = {
        EmployeeIds: getAllCurrentPageEmployees.value,
      };
      if (type == 'assign-all') {
        PostEmployees(projectId.value, params).then(() => {
          afterHandleClick(type);
        });
      } else {
        PatchEmployees(projectId.value, params).then(() => {
          afterHandleClick(type);
        });
      }
    };
    const filterVisibility = ref(false);
    const setFilterVisibility = () => {
      filterVisibility.value = !filterVisibility.value;
    };
    return {
      drawerState,
      projectName,
      handleDrawerClose,
      handleClickAll,
      drawerListContainerLoader,
      drawerFilterOptions,
      localSelectedDrawerFilter,
      setFilterVisibility,
      filterVisibility,
      projectNameDescription,
    };
  },
};
</script>

<style lang="scss" scoped>
.drawer-container {
  display: grid;
  line-height: 24px;
  flex-direction: column;
  grid-template-rows: auto auto 65px 1fr 105px;
  height: 100%;

  .drawer-header,
  .drawer-search,
  .drawer-pagination,
  .drawer-list,
  .drawer-allBtns {
    padding: 14px 16px;
    border: 1px solid $neutral-40;
    border-right: 0;
    border-top: 0;
  }

  .drawer-header {
    display: grid;
    row-gap: 8px;
    color: $neutral-800;
    overflow-wrap: anywhere;

    label {
      font-weight: 500;
    }

    .--label {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .SproutIcon-cross-regular {
        color: $neutral-400;
      }

      .SproutIcon-cross-regular:hover {
        cursor: pointer;
        color: $green-300;
      }
    }
  }

  .drawer-list {
    padding-right: 2px;
    padding-top: 0;
    padding-bottom: 0;
    flex-direction: column;
    overflow-y: auto;
  }

  .drawer-allBtns {
    display: grid;
    row-gap: 8px;
    font-weight: 400;
  }

  .search-div {
    display: grid;
    column-gap: 16px;
    grid-template-columns: 2fr auto;
  }

  .searchBy-btn {
    padding: 4px 8px;
    font-size: 16px;
  }

  .drawer-search {
    display: grid;
    row-gap: 16px;
  }

  .btn-outline-success:hover {
    color: $green-300;
    background-color: $green-50;
  }

  .btn-outline-success:active,
  .btn-outline-success.active,
  .btn-outline-success.dropdown-toggle.show {
    color: $green-300;
    background-color: $green-75;
  }

  .SproutIcon {
    vertical-align: middle;
  }
}

.dropdown-filter {
  :deep(.select-wrapper) {
    .form-control ~ .form-label {
      color: $neutral-50;
    }

    .form-control:focus ~ .form-label {
      color: $neutral-200;
    }

    .select-input.focused ~ .form-notch .form-notch-leading,
    .form-outline .form-control:focus ~ .form-notch .form-notch-leading {
      border-top-color: $green-300;
      border-bottom-color: $green-300;
      border-left-color: $green-300;
    }

    .select-input.focused ~ .form-notch .form-notch-middle,
    .form-outline .form-control:focus ~ .form-notch .form-notch-middle {
      border-color: $green-300;
    }

    .select-input.focused ~ .form-notch .form-notch-trailing,
    .form-outline .form-control:focus ~ .form-notch .form-notch-trailing {
      border-top-color: $green-300;
      border-bottom-color: $green-300;
      border-left-color: $green-300;
      border-right-color: $green-300;
    }

    .select-input.focused ~ .select-arrow {
      color: $green-75;
    }
  }

  :deep(.select-options-wrapper) {
    margin-top: 0.5px;

    .select-option.active,
    .select-option.selected.active {
      background-color: $green-75;
    }

    .select-option:hover:not(.disabled) {
      background-color: $green-50;
    }

    :deep(.select-dropdown) {
      border-radius: 4px;
      border-color: $neutral-50;
    }
  }
}
:deep(.btn) {
  box-shadow: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  &.btn-primary {
    background-color: $blue-300;
    &:hover {
      background-color: $blue-200;
    }
    &:active {
      background-color: $blue-400;
      &:focus {
        box-shadow: none;
      }
    }
  }
  &.btn-outline-danger {
    color: $red-300;
    border-color: $red-300;
    &:hover {
      background-color: $red-50;
    }
    &:active {
      background-color: $red-75;
    }
  }
}
</style>
